export default {
  type: {
    asc: 'type_ASC',
    desc: 'type_DESC',
  },
  customReason: {
    asc: 'reason_ASC',
    desc: 'reason_DESC',
  },
  accountId: {
    asc: 'accountId_ASC',
    desc: 'accountId_DESC',
  },
  userId: {
    asc: 'userId_ASC',
    desc: 'userId_DESC',
  },
  itemId: {
    asc: 'itemId_ASC',
    desc: 'itemId_DESC',
  },
  createdDate: {
    asc: 'startDate_ASC',
    desc: 'startDate_DESC',
  },
  date: {
    asc: 'startDate_ASC',
    desc: 'startDate_DESC',
  },
};
